import {
  GET_HOSTS_BY_CONTACT_FAILED,
  GET_HOSTS_BY_CONTACT_LOADING,
  GET_HOSTS_BY_CONTACT_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export const getHostByContactReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any; status: any }
) => {
  switch (action.type) {
    case GET_HOSTS_BY_CONTACT_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_HOSTS_BY_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_HOSTS_BY_CONTACT_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
};
